import { render, staticRenderFns } from "./drawAddNum.vue?vue&type=template&id=c8d5a8b0&scoped=true"
import script from "./drawAddNum.vue?vue&type=script&lang=js"
export * from "./drawAddNum.vue?vue&type=script&lang=js"
import style0 from "./drawAddNum.vue?vue&type=style&index=0&id=c8d5a8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d5a8b0",
  null
  
)

export default component.exports